import { Deserializable } from '../../protocols/deserializable';
import { GoverningJurisdictionType } from '../../employers/employer-history/types/governing-jurisdiction-type';
import { EmployerPlanDesignatedUnit } from '../../employers/plans/employer-plan-designated-unit';
import { EmploymentType } from '../../employers/employer-history/types/employment-type';
import { EmploymentStatusType } from '../../employers/employer-history/types/employment-status-type';
import * as moment from 'moment';
import { State } from '../../types/dto/state';
import { LeaveDetails } from './leave-details';
import { EmploymentStatusTypeId } from '../../employers/enum/employment-status-type-id';
import { EmploymentStatusChangeReasonId } from '../../employers/enum/employment-status-change-reason-id';
import { BaseType } from '../../base/base-type';

export class EmploymentHistory implements Deserializable {
  id!: number;
  memberId!: number;
  employerId!: number;
  employer!: string;
  designatedUnitClientUnitId!: string | null;
  designatedUnit!: EmployerPlanDesignatedUnit;
  governingJurisdictionId!: number;
  governingJurisdiction!: GoverningJurisdictionType;
  provinceOfEmploymentId!: number;
  provinceOfEmployment!: State;
  employmentTypeId!: number;
  employmentType!: EmploymentType;
  employmentStatusId!: EmploymentStatusTypeId;
  onLeave!: boolean;
  employmentStatus!: EmploymentStatusType;
  statusChangeReasonId!: EmploymentStatusChangeReasonId | null;
  statusChangeReason!: BaseType | null;
  leaveDetailsId!: number | null;
  leaveDetails!: LeaveDetails | null;
  workFromHome!: boolean;
  startDate!: string;
  endDate!: string | null;
  contributionStartDate!: string;
  lastExpectedContributionDate!: string | null;
  lastProcessedContributionDate!: string | null;
  annualSalary!: number | null;

  // Not From API
  public formattedStartDate!: string;
  public formattedEndDate!: string | null;
  public formattedContributionStartDate!: string;
  public formattedLastExpectedContributionDate!: string;
  public formattedLastProcessedContributionDate!: string;

  onDeserialize(): void {
    if (!!this.startDate) {
      this.formattedStartDate = moment.utc(this.startDate).format('MMM D, YYYY');
    }
    if (!!this.endDate) {
      this.formattedEndDate = moment.utc(this.endDate).format('MMM D, YYYY');
    }
    if (!!this.contributionStartDate) {
      this.formattedContributionStartDate = moment.utc(this.contributionStartDate).format('MMM D, YYYY');
    }
    if (!!this.lastExpectedContributionDate) {
      this.formattedLastExpectedContributionDate = moment.utc(this.lastExpectedContributionDate).format('MMM D, YYYY');
    }
    if (!!this.lastProcessedContributionDate) {
      this.formattedLastProcessedContributionDate = moment
        .utc(this.lastProcessedContributionDate)
        .format('DD / MM / YYYY');
    }
    if (!!this.designatedUnit) {
      this.designatedUnit = window?.injector?.Deserialize?.instanceOf(EmployerPlanDesignatedUnit, this.designatedUnit);
    }
    if (!!this.governingJurisdiction) {
      this.governingJurisdiction = window?.injector?.Deserialize?.instanceOf(
        GoverningJurisdictionType,
        this.governingJurisdiction
      );
    }
    if (!!this.provinceOfEmployment) {
      this.provinceOfEmployment = window?.injector?.Deserialize?.instanceOf(State, this.provinceOfEmployment);
    }
    if (!!this.employmentType) {
      this.employmentType = window?.injector?.Deserialize?.instanceOf(EmploymentType, this.employmentType);
    }
    if (!!this.employmentStatus) {
      this.employmentStatus = window?.injector?.Deserialize?.instanceOf(EmploymentStatusType, this.employmentStatus);
    }
    if (!!this.statusChangeReason) {
      this.statusChangeReason = window?.injector?.Deserialize?.instanceOf(BaseType, this.statusChangeReason);
    }
    if (!!this.leaveDetails) {
      this.leaveDetails = window?.injector?.Deserialize?.instanceOf(LeaveDetails, this.leaveDetails);
    }
    if (!this.leaveDetails) {
      this.leaveDetails = new LeaveDetails();
    }
  }
}
